import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";

export default function RegisterPage() {
  const { register, error } = useAuth();
  const nav = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    const ok = await register(email, password, name);
    setSubmitting(false);
    if (ok) nav("/dashboard", { replace: true });
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-zinc-950 text-zinc-50 p-6">
      <form
        onSubmit={onSubmit}
        data-testid="register-form"
        className="w-full max-w-sm space-y-6 border border-zinc-800 bg-zinc-900/60 backdrop-blur rounded-lg p-8"
      >
        <div>
          <div className="label-eyebrow mb-3">Create account</div>
          <h2 className="font-display text-3xl font-bold">Start your first journal</h2>
        </div>
        <div className="space-y-2">
          <Label className="label-eyebrow">Name</Label>
          <Input
            data-testid="register-name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Your name"
            className="bg-zinc-950 border-zinc-800"
          />
        </div>
        <div className="space-y-2">
          <Label className="label-eyebrow">Email</Label>
          <Input
            data-testid="register-email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            className="bg-zinc-950 border-zinc-800"
          />
        </div>
        <div className="space-y-2">
          <Label className="label-eyebrow">Password</Label>
          <Input
            data-testid="register-password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            minLength={6}
            className="bg-zinc-950 border-zinc-800"
          />
        </div>
        {error && <div data-testid="register-error" className="text-sm text-red-400">{error}</div>}
        <Button data-testid="register-submit" disabled={submitting} className="w-full bg-blue-600 hover:bg-blue-500">
          {submitting ? "Creating…" : "Create account"}
        </Button>
        <p className="text-sm text-center text-zinc-400">
          Already have an account?{" "}
          <Link to="/login" data-testid="goto-login" className="text-blue-400 hover:underline">Sign in</Link>
        </p>
      </form>
    </div>
  );
}
